<div class="container-fluid">
  <!-- Page Header with Utility Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Payments Made Report</h1>

    <!-- Utility Buttons -->
    <div class="d-flex align-items-center" style="margin-top: 0.5rem;">
      <button style="background-color: transparent !important; border: none;"
        (click)="onPrint()"
        type="button"
        mat-icon-button
        class="mb-1"
        matTooltip="Print payments made report"
        matTooltipPosition="below"
        aria-label="Print payments made report">
        <mat-icon style="color: #1C3F8B;">print</mat-icon>
      </button>
    </div>
  </div>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Filter
      </mat-panel-title>
      <mat-panel-description>
        <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">
      <div class="row">

        <!-- Date Range Filter -->
        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Enter a date range</mat-label>
            <input matInput
                [owlDateTime]="picker_daterange_start_end"
                [owlDateTimeTrigger]="picker_daterange_start_end"
                [selectMode]="'range'"
                [(ngModel)]="dateRange"
                placeholder="Select date range"
                readonly
                name="field_date_and_time"
                (dateTimeChange)="dateRangeChange($event)">
            <span class="cursor-pointer" matSuffix [owlDateTimeTrigger]="picker_daterange_start_end">
                <mat-icon>calendar_today</mat-icon>
            </span>
            <owl-date-time #picker_daterange_start_end [pickerType]="'calendar'"></owl-date-time>
          </mat-form-field>
        </div>

        <!-- Enrollment Autocomplete -->
        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Enrollment</mat-label>
            <input name="field_enrollment_name" (input)="onEnrollmentAutocomplete($event)" matInput ngModel
              [matAutocomplete]="autoCompleteEnrollment">
            <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
              <mat-icon>manage_accounts</mat-icon>
            </button>
          </mat-form-field>
          <mat-autocomplete #autoCompleteEnrollment="matAutocomplete" (optionSelected)="onSubmit(f)">
            <mat-option *ngFor="let option of autoCompleteEnrollmentOptions" [value]="option.label + ' ' + '(' + option.value + ')'">
              {{option.label}} ({{option.value}})
            </mat-option>
          </mat-autocomplete>
        </div>

        <!-- Department Filter  -->
        <div class="col-12 col-sm-6 col-lg">
            <mat-form-field class="full-width-field">
              <mat-label>Select Department...</mat-label>
              <mat-select
                name="field_department_name"
                ngModel
                (selectionChange)="onSubmit(f)">
                <mat-option value="all">All</mat-option>
                <mat-option
                *ngFor="let department of departmentData"
                [value]="department.key">{{ department.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
        </div>

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
              <mat-label>Student Name</mat-label>
              <input
                  name="field_student_id"
                  (input)="onAutocompleteStudentAccount($event)"
                  matInput
                  ngModel
                  [matAutocomplete]="studentautocomplete"
                  >
              <button type="button" matSuffix mat-icon-button
                  aria-label="manage_accounts">
                  <mat-icon>manage_accounts</mat-icon>
              </button>
          </mat-form-field>
          <mat-autocomplete
              #studentautocomplete="matAutocomplete"
              (optionSelected)="onSubmit(f)">
              <mat-option *ngFor="let option of autoCompleteStudentAccountOptions"
                  [value]="option.value">
                  {{option.label}} ({{option.value}})
              </mat-option>
          </mat-autocomplete>
      </div>

        <!-- Package Name Filter -->
        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Package Name</mat-label>
            <input
              name="field_package_name"
              matInput
              ngModel
              (input)="onPackageAutocomplete($event)"
              [matAutocomplete]="autoCompletePackage">
            <button type="button" matSuffix mat-icon-button aria-label="search">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
          <mat-autocomplete #autoCompletePackage="matAutocomplete" (optionSelected)="onSubmit(f)">
            <mat-option *ngFor="let option of autoCompletePackageOptions" [value]="option.label">
              {{option.label}}
            </mat-option>
          </mat-autocomplete>
        </div>

        <!-- Instructor Filter -->
        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
            <mat-label>Instructor</mat-label>
            <mat-select
              matInput
              ngModel
              name="field_instructor_target_id"
              (selectionChange)="onSubmit(f)">
              <mat-option>None</mat-option>
              <mat-option
                *ngFor="let element of this._fieldsService.instructorData()"
                [value]="element.uid">
                {{ element.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </div>

      <div class="row">
      <section class="section">
        <mat-checkbox
            name="Sundry"
            class="margin"
            ngModel
            (change)="onSubmit(f)">Sundry</mat-checkbox>
        <mat-checkbox
            name="Misc"
            class="margin"
            ngModel
            (change)="onSubmit(f)">Misc</mat-checkbox>

        <mat-checkbox
            name="Lesson"
            class="margin"
            ngModel
            (change)="onSubmit(f)">Lesson</mat-checkbox>
      </section>

        <section class="section">
          <div class="float-end bring-inline">
            <button (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear
              <!-- <mat-icon (click)="resetForm()" aria-hidden="false" aria-label="Menu dropdown" class=""></mat-icon> -->
            </button>
          </div>

        </section>

      </div>


    </form>

  </mat-expansion-panel>

  <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

  <div class="table-responsive-sticky table-responsive">

    <table mat-table #displayTable [dataSource]="groupedDataSource" matSort (matSortChange)="sortData($event)" class="mt-4">


      <!-- id Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by id">
          Receipt #
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="isPaymentRow(element)">{{ element.data?.id }}</span>
        </td>
      </ng-container>

      <!-- field_date_and_time Column -->
      <ng-container matColumnDef="field_date_and_time">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_date_and_time">
          Date Paid
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="isPaymentRow(element)">{{ formatDate(element.data?.field_date_and_time) }}</span>
        </td>
      </ng-container>

      <!-- field_student_name Column -->
      <ng-container matColumnDef="field_student_name">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_student_name">
          Student Name
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="isPaymentRow(element)">{{ element.data?.field_student_name }}</span>
          <strong *ngIf="isSubtotalRow(element)">Subtotal for {{ formatDate(element.date) }}</strong>
          <strong *ngIf="isTotalRow(element)">TOTAL</strong>
        </td>
      </ng-container>

      <!-- field_student_department Column -->
      <ng-container matColumnDef="field_student_department">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_student_department">
          Student Department
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="isPaymentRow(element)">{{ element.data?.field_student_department }}</span>
        </td>
      </ng-container>

      <!-- field_enrollment_package_name_label Column -->
      <ng-container matColumnDef="field_enrollment_package_name_label">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_enrollment_package_name_label">
          Enrollment
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="isPaymentRow(element)">{{ element.data?.enrollment_title }}</span>
        </td>
      </ng-container>

      <!-- field_gross_tuition Column -->
      <ng-container matColumnDef="field_gross_tuition">
        <th mat-header-cell *matHeaderCellDef class="text-end" sortActionDescription="Sort by field_gross_tuition">
          Amount Paid
        </th>
        <td mat-cell *matCellDef="let element" class="text-end">
          <span *ngIf="isPaymentRow(element)">{{ element.data?.field_gross_tuition | studioCurrency }}</span>
          <strong *ngIf="isSubtotalRow(element) && !selectedInstructorId">{{ element.subtotalAmount | studioCurrency }}</strong>
          <strong *ngIf="isTotalRow(element) && !selectedInstructorId">{{ element.totalAmount | studioCurrency }}</strong>
        </td>
      </ng-container>

      <!-- instructor_percentage Column (only when filtered by instructor) -->
      <ng-container matColumnDef="instructor_percentage">
        <th mat-header-cell *matHeaderCellDef>
          Allotted %
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="isPaymentRow(element)">{{ (element.data?.instructor_percentage || 0) | number:'1.0-2' }}%</span>
        </td>
      </ng-container>

      <!-- commission_amount Column (only when filtered by instructor) -->
      <!-- Labelled "Reported $" rather than "Commission" at the client's request:
           staff read "commission" as pay owed to them, which this is not. -->
      <ng-container matColumnDef="commission_amount">
        <th mat-header-cell *matHeaderCellDef class="text-end">
          Reported $<span *ngIf="selectedInstructorName"> &mdash; {{ selectedInstructorName }}</span>
        </th>
        <td mat-cell *matCellDef="let element" class="text-end">
          <span *ngIf="isPaymentRow(element)">
            {{ element.data?.commission_amount | studioCurrency }}
            <small class="text-muted ms-1">{{ commissionFormula(element.data) }}</small>
          </span>
          <strong *ngIf="isSubtotalRow(element)">{{ element.subtotalAmount | studioCurrency }}</strong>
          <strong *ngIf="isTotalRow(element)">
            <span *ngIf="selectedInstructorName">Total to {{ selectedInstructorName }}: </span>{{ element.totalAmount | studioCurrency }}
          </strong>
        </td>
      </ng-container>

      <!-- field_payment_type_label Column -->
      <ng-container matColumnDef="field_payment_type_label">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_payment_type_label">
          Payment Type
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="isPaymentRow(element)">{{ element.data?.field_payment_type_label }}</span>
        </td>
      </ng-container>

      <!-- field_instructor_label Column -->
      <ng-container matColumnDef="field_instructor_label">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by field_instructor_label">
          Instructor
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="isPaymentRow(element)">{{ element.data?.field_first_name_instructor }} {{ element.data?.field_last_name_instructor }}</span>
        </td>
      </ng-container>

      <!-- REPLACE Column -->
      <ng-container matColumnDef="closer">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by closer">
          Closer
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="isPaymentRow(element)">{{ element.data?.field_first_name_executive }} {{ element.data?.field_last_name_executive }}</span>
        </td>
      </ng-container>

      <!-- Footer for pagination -->
      <ng-container matColumnDef="pagination-footer">
        <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
          <mat-paginator (page)="pageChanged($event)" [pageSizeOptions]="onPageSizeOptions()" [length]="totalRowCount"
            [disabled]="ShowProgressBar"
            [pageSize]="pageSize" [pageIndex]="paginationIndex" aria-label="Select page of view"></mat-paginator>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
             <tr mat-row matRipple
           *matRowDef="let row; columns: displayedColumns;"
           [ngClass]="{'subtotal-row': isSubtotalRow(row), 'payment-row': isPaymentRow(row), 'total-row': isTotalRow(row)}">
       </tr>
      <tr mat-footer-row *matFooterRowDef="['pagination-footer']; sticky: true"></tr>
    </table>

  </div>
</div>
